import React from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import {
  AddSequrityQuestionAction,
  UpdateSequrityQuestionAction,
} from "store/middlewares/securityQuestions";
import { InputTextarea } from "components/atoms";
import { Button } from "components/ui";

function ModalEditSequrityQuestion({ row, filter }) {
  const dispatch = useDispatch();
  const handleSubmit = (values) => {
    if (row) {
      dispatch(UpdateSequrityQuestionAction({ ...values, id: row.id }));
    } else {
      dispatch(AddSequrityQuestionAction({ ...values, filter }));
    }
  };

  const formik = useFormik({
    initialValues: {
      question: row?.question ? row?.question : "",
    },
    validationSchema: Yup.object({
      question: Yup.string()
        .required("Question is required")
        .min(10, "Minimum 10 characters are required")
        .max(100, "Maximum 100 characters are required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <InputTextarea
        textareaClassName={`rounded-lg border border-solid ${
          !formik.errors.question && `border-zinc-400`
        } w-full px-2 py-2 mt-2 no-scrollbar`}
        label={
          <>
            Question{" "}
            <span
              style={{ color: "#b3b3bc", fontSize: 12, fontStyle: "italic" }}
            >
              (Minimum 10 characters are required)
            </span>
          </>
        }
        name="question"
        onChange={(e) => {
          const cleaned = e.target.value.replace(/^\s+/, "");
          formik.setFieldValue("question", cleaned);
        }}
        onBlur={formik.handleBlur}
        error={formik.errors.question && formik.touched.question}
        errorMsg={formik.errors.question}
        value={formik.values.question}
        placeholder="Enter Question"
        isRequired={false}
      />
      <div style={{ textAlign: "right", fontSize: 12, color: "#b3b3bc" }}>
        {formik.values.question.length} / 100
      </div>
      <div className="flex justify-end">
        <Button size={"lg"} type={"submit"} sx={{ fontSize: "16px" }}>
          {row ? "Update" : "Add"}
        </Button>
      </div>
    </form>
  );
}

export default ModalEditSequrityQuestion;
